/**
 * Tuning constants used by the client. Values come from
 * `108_Tuning_Constants.md` — change them THERE first, then here, and record
 * why in `001_DECISIONS.md`. Never inline a balance number in gameplay code.
 */

export const TILE = 48; // px
export const CAMERA_TILES_X = 20;
export const CAMERA_TILES_Y = 12;
export const BASE_WIDTH = TILE * CAMERA_TILES_X; // 960
export const BASE_HEIGHT = TILE * CAMERA_TILES_Y; // 576

/** US 01.01 — movement. */
export const WALK_SPEED = 4 * TILE; // px/s (4 tiles/sec)
export const ACCEL_TIME_MS = 100; // 0 → full in ≤100ms
export const STOP_TIME_MS = 80; // full → 0 in ≤80ms

/** Collision box: 32×24, anchored bottom-centre of the sprite (owner decision). */
export const COLLIDER_W = 32;
export const COLLIDER_H = 24;

/** US 01.01 — camera feel. */
export const CAMERA_DAMPING = 0.1;
export const CAMERA_LOOKAHEAD = TILE; // 1 tile in the direction of travel

/** Fixed-timestep logic rate (106 §3). */
export const TICK_HZ = 60;
export const TICK_MS = 1000 / TICK_HZ;

/** US 01.02 — indicator timings (render-side fades). */
export const INDICATOR_FADE_IN_MS = 200;
export const INDICATOR_FADE_OUT_MS = 100;

/** Player/NPC sprite footprint (111 §4). */
export const SPRITE_W = 48;
export const SPRITE_H = 64;
